import React, { useRef } from 'react';
import SignatureCanvas from 'react-signature-canvas';
const SignaturePad = ({ onChange }) => {
    const sigPadRef = useRef(null);
    const clear = () => {
        if (sigPadRef.current) {
            sigPadRef.current.clear();
            onChange('');
        }
    };
    const save = () => {
        if (sigPadRef.current && !sigPadRef.current.isEmpty()) {
            onChange(sigPadRef.current.getTrimmedCanvas().toDataURL('image/png'));
        }
    };
    return (<div className="signature-pad-container">
            <div className="border border-gray-300 rounded">
                <SignatureCanvas ref={sigPadRef} canvasProps={{
            className: 'signature-canvas',
            width: 400,
            height: 200
        }} onEnd={save}/>
            </div>
            <div className="mt-2 space-x-2">
                <button type="button" onClick={clear} className="px-3 py-1 text-sm bg-gray-100 rounded hover:bg-gray-200">
                    Löschen
                </button>
            </div>
        </div>);
};
export default SignaturePad;
